export default {"src":"/_next/static/media/profileDefaultGreen.27a5142c.svg","height":80,"width":80};